import { http } from "./httpClient";

function buildQuery(params) {
  const q = new URLSearchParams();
  Object.entries(params || {}).forEach(([k, v]) => {
    if (v !== undefined && v !== null && v !== "") q.set(k, v);
  });
  const s = q.toString();
  return s ? `?${s}` : "";
}

export const contentApi = {
  list: (params) => http.get(`/content/${buildQuery(params)}`),
  get: (id) => http.get(`/content/${id}/`),

  /**
   * payload: { instagram_account, content_type, caption,
   *            media (File or File[] -- 2+ files auto-promotes a POST to a
   *            carousel server-side), scheduled_at (ISO string), timezone,
   *            publish_now, collaborators (string[], <=3), is_ai_generated
   *            (bool), user_tags (string[], single-media only),
   *            location_page_id (Reels only) }
   */
  create: (payload) => {
    const form = new FormData();
    Object.entries(payload).forEach(([key, value]) => {
      if (value === undefined || value === null || value === "") return;
      if (key === "media" && Array.isArray(value)) {
        value.forEach((file) => form.append("media", file));
      } else if ((key === "collaborators" || key === "user_tags") && Array.isArray(value)) {
        if (value.length) form.append(key, JSON.stringify(value));
      } else {
        form.append(key, value);
      }
    });
    return http.postForm("/content/", form);
  },

  /**
   * patch: any of { caption, scheduled_at, timezone, collaborators (string[]),
   * user_tags (string[]), is_ai_generated (bool), location_page_id,
   * location_name, audio_id, audio_name }. Only SCHEDULED/FAILED content is
   * editable server-side; media itself can't be replaced via this call.
   * collaborators/user_tags are JSON-stringified before sending -- the
   * backend's array-field parser is shared with the create() route above,
   * which only ever receives those fields as JSON strings (FormData has no
   * native array type), so PATCH's JSON body matches that same contract.
   */
  update: (id, patch) => {
    const body = { ...patch };
    for (const key of ["collaborators", "user_tags"]) {
      if (Array.isArray(body[key])) body[key] = JSON.stringify(body[key]);
    }
    return http.patch(`/content/${id}/`, body);
  },
  cancel: (id) => http.post(`/content/${id}/cancel/`),
  remove: (id) => http.delete(`/content/${id}/`),
  retry: (id) => http.post(`/content/${id}/retry/`),

  scheduled: () => contentApi.list({ status: "SCHEDULED" }),
  published: () => contentApi.list({ status: "PUBLISHED" }),
  failed: () => contentApi.list({ status: "FAILED" }),
};
